@let changed = change();
<app-label-value
  label="Affectation"
  [value]="assignmentValue"
  [class.changed]="!!changed"
  [matTooltip]="changed"
></app-label-value>
